/**
 * Custom Klaviyo tracking
 */

const initWishlistTrackingEvents = () => {
  const selector = '[data-product-handle]';

  document.addEventListener('click', (e) => {
    e.stopPropagation();
    if (klaviyo == undefined || !klaviyo) return;

    const target = e.target;
    console.log('Clicked', target);

    const { productHandle } = target.dataset;
    console.log('Clicked', productHandle);

    if (productHandle) {
      const isInWishlist = localStorage.getItem('shopify-wishlist')?.split(',').includes(productHandle);
      console.log('is add event', isInWishlist);

      const eventName = isInWishlist ? 'Remove from wishlist' : 'Add to wishlist';
      const item = {
        'ProductName': productHandle,
      };
      
      klaviyo.push(['track', eventName, item]);
      console.log('Pushed event:', ['track', eventName, item]);
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  initWishlistTrackingEvents();
});